export default {
      id: "arrow-usage",
      viewBox: "0 0 12 8",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#arrow",
      toString: function () {
        return this.url;
      }
    }